export default __webpack_public_path__ + "static/media/tractor.1576008b.png";